import React, { useState } from 'react';
import { Card, Grid, Button } from '@material-ui/core';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import './login/Login.scss';

const useStyles = makeStyles(({ palette, ...theme }) => ({
  cardHolder: {
    background: '#1A2038',
  },
  card: {
    maxWidth: 800,
    borderRadius: 12,
    margin: '1rem',
  },
}));

const ForgotPassword = () => {
  const [state, setState] = useState({});
  const classes = useStyles();

  const handleChange = ({ target: { name, value } }) => {
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleFormSubmit = (event) => {
    console.log(state);
  };

  let { email } = state;
  let { password } = state;

  return (
    <>
      <div className={clsx('flex justify-center items-center min-h-full-screen')} id="FirstLogin">

        <div className='box-login'>
          <div className='logo'>
            <img src={`${process.env.PUBLIC_URL} /assets/Shop/logo_login.png`} />
          </div>
          <div className='tag-service'>
            <span className='sv'>Sales View</span>
            <span className='ac'>APP Control</span>
          </div>
          <h2>パスワードを変更する</h2>
          <div className='form-login'>
            <p className='text-center_pc text-left_sp'>新しいパスワードを入力して<br className='pc' />「パスワードを変更する」ボタンから申請してください。<br />
              後ほど登録されているメールアドレスまで確認メールをお届けします。<br />
              メール内のURLをクリックしてパスワード変更を確定させてください。</p>
            <ValidatorForm onSubmit={handleFormSubmit}>
              <TextValidator
                className="w-full"
                variant="outlined"
                label="Email"
                onChange={handleChange}
                type="email"
                name="email"
                autoComplete="email"
                //size="small"
                value={email || ''}
                validators={['required', 'isEmail']}
                errorMessages={['パスワードを変更したい登録済みのメールアドレスを入力してください。', 'メールアドレスの形式にしてください']}
                placeholder={['メールアドレス']}
              />

              <TextValidator
                className="mb-6 w-full"
                variant="outlined"
                label="Password"
                onChange={handleChange}
                type="password"
                name="password"
                //autoComplete="password"
                //size="small"
                value={password || ''}
                validators={['required', 'isEmail']}
                errorMessages={['変更したいパスワードを入力してください。']}
                placeholder={['新しいパスワードを入力ください']}
              />

              <div className="flex items-center justify-center">
                <Button variant="contained" color="primary" type="submit">
                  パスワードを<br className='sp' />変更する
                </Button>
                <span className="ml-4 mr-4">or</span>
                <Link to="/session/signin">
                  <Button variant="contained" color="secondary" type="submit" className="capitalize">ログイン画面に<br className='sp' />戻る</Button>
                </Link>
              </div>
            </ValidatorForm>

          </div>
        </div>

      </div>


    </>

  );
};

export default ForgotPassword;
